import { contentEntries } from './content-entries';
import { GatherContentMigrationHelper } from './gather-content-migration-helper';
import { gridComponents } from './roche-grid';
import { HtmlBlob } from './html-blob';
import { Podcast } from './podcast';
import { responsiveTable } from './responsive-table';
import { RocheBreadcrumbs } from './roche-breadcrumbs';
import { RocheButton } from './roche-button';
import { RocheCookieBannerLink } from './roche-cookie-banner-link';
import { RocheDownloadTeaser } from './roche-download-teaser';
import { RocheFooter } from './roche-footer';
import { RocheGlobalConfig } from './global-config';
import { RocheHeadline } from './roche-headline';
import { RocheLeadText } from './roche-lead-text';
import { RocheRichtext } from './roche-richtext';
import { RocheStagingHero } from './roche-staging-hero';
import { RocheTeaser } from './roche-teaser';
import { RocheTeaserAuto } from './roche-teaser-auto';
import { RocheTextLink } from './roche-text-link';
import { RochePublishedDate } from './roche-published-date';
import { RocheStockPrice } from './roche-stock-price';
import { RocheTeaserExternal } from './roche-teaser-external';
import { RocheHeroTeaserExternal } from './roche-hero-teaser-external';
import { RocheHeroTeaser } from './roche-hero-teaser';
import { RocheSlider } from './roche-slider';
import { RocheStoryTeaser } from './roche-story-teaser';
import { RocheTeaserWall } from './roche-teaser-wall';
import { RocheStoryTeaserAuto } from './roche-story-teaser-auto';
import { RocheStoryStagingHero } from './roche-story-staging-hero';
import { RocheTeaserSlider } from './roche-teaser-slider';
import { RocheSafetyOfficersOverview } from './roche-safety-officers-overview';
import { RocheSafetyReportingOverview } from './roche-safety-reporting-overview';
import { PubMed } from './pub-med';
import { RocheInvestorEventsList } from './roche-investor-events-list';
import { RocheInvestorUpdatesList } from './roche-investor-updates-list';
import { RocheMediaEventsList } from './roche-media-events-list';
import { RocheMediaReleases } from './roche-media-releases';
import { RocheMediaSwitzerland } from './roche-media-switzerland';
import { ScrollTracking } from './scroll-tracking';
import { forms } from './forms';
import { RocheAnimatedWords } from './roche-animated-words';
import { RocheQuote } from './roche-quote';
import { RocheWorldwideLocationOverview } from './roche-worldwide-location-overview';
import { RocheContactPerson } from './roche-contact-person';
import { RocheSubline } from './roche-subline';
import { RocheAvatar } from './roche-avatar';
import { RocheIcon } from './roche-icon';
import { RocheBackToBranch } from './roche-back-to-branch';
import { RocheHighlightBox } from './roche-highlight-box';
import { RochePipeline } from './roche-pipeline';
import { RochePipelineChanges } from './roche-pipeline-changes';
import { RocheMediaReleasesInvestorUpdatesAdhoc } from './roche-media-releases-investor-updates-adhoc';
import { RochePipelineDiagnostics } from './roche-pipeline-diagnostics';
import { Marketo } from './marketo';
import { RocheHorizontalCenter } from './roche-horizontal-center';
import { RochePatientOrganisations } from './roche-patient-organisations';

// eslint-disable-next-line import/no-default-export
export default {
  ...contentEntries,
  ...gridComponents,
  ...forms,
  ...responsiveTable,
  GatherContentMigrationHelper,
  HtmlBlob,
  Marketo,
  Podcast,
  RocheBreadcrumbs,
  RocheButton,
  RocheCookieBannerLink,
  RocheDownloadTeaser,
  RocheFooter,
  RocheGlobalConfig,
  RocheHeadline,
  RocheLeadText,
  RocheRichtext,
  RocheStagingHero,
  RocheTeaser,
  RocheTeaserAuto,
  RocheTextLink,
  RochePublishedDate,
  RocheMediaReleasesInvestorUpdatesAdhoc,
  RocheStockPrice,
  RocheTeaserExternal,
  RocheHeroTeaserExternal,
  RocheHeroTeaser,
  RocheStoryTeaser,
  RocheTeaserWall,
  RocheStoryTeaserAuto,
  RocheStoryStagingHero,
  RocheTeaserSlider,
  RocheSlider,
  RocheSafetyOfficersOverview,
  RocheSafetyReportingOverview,
  PubMed,
  RocheInvestorEventsList,
  RocheInvestorUpdatesList,
  RocheMediaEventsList,
  RocheMediaReleases,
  RocheMediaSwitzerland,
  ScrollTracking,
  RocheAnimatedWords,
  RochePatientOrganisations,
  RocheQuote,
  RocheWorldwideLocationOverview,
  RocheContactPerson,
  RocheSubline,
  RocheAvatar,
  RocheIcon,
  RocheBackToBranch,
  RocheHighlightBox,
  RochePipeline,
  RochePipelineChanges,
  RochePipelineDiagnostics,
  RocheHorizontalCenter,
};
